import { useState } from 'react';
import { withNamespaces } from 'react-i18next';
import { useLocation, useParams } from 'react-router-dom';
import {
    Card,
    CardBody,
    Col,
    Container,
    Row,
    Spinner,
} from 'reactstrap';

import Navigator from 'src/components/Navigator';
import { ROUTE_PATH_ADMIN_GUARD_FREIGHTS_LIST } from 'src/modules/3rd-party-management/constants';
import CarrierBids from './components/CarrierBids';
import FreightHeader from './components/FreightHeader';
import Overview from './components/Overview';
import useCarrierGuardFreightDetails from './hooks/useCarrierGuardFreightDetails';

const GuardFreightDetails = ({
    t,
}) => {
    const { freightId } = useParams();
    const location = useLocation();
    const [activeTab, setActiveTab] = useState(
        new URLSearchParams(location.search).get('tab') || 'overview'
    );

    const {
        data: freight,
        isError,
        isFetching,
    } = useCarrierGuardFreightDetails({
        freightId,
        t,
    });

    if (isFetching) {
        return (
            <div className="page-content">
                <Container className="py-5 text-center" fluid>
                    <Spinner color="primary" />
                    <p className="mt-2">{t('Loading')}...</p>
                </Container>
            </div>
        );
    }

    if (isError || !freight) {
        return (
            <div className="page-content">
                <Container fluid>
                    <div className="alert alert-danger" role="alert">
                        {t(isError ? 'Unable to load freight details. Please try again.' : 'Freight not found.')}
                    </div>
                </Container>
            </div>
        );
    }

    return (
        <div className="page-content carrier-guard-page carrier-guard-freight-details-page">
            <Container fluid>
                <Row>
                    <Col className="mb-4" lg="12">
                        <Navigator
                            breadCrumbs={[
                                {
                                    title: 'Freights',
                                    link: ROUTE_PATH_ADMIN_GUARD_FREIGHTS_LIST,
                                },
                                {
                                    title: freight.reference,
                                    link: '#',
                                },
                            ]}
                        />
                    </Col>
                </Row>

                <FreightHeader
                    activeTab={activeTab}
                    freight={freight}
                    onTabChange={setActiveTab}
                />

                {activeTab === 'overview' && (
                    <Overview freight={freight} />
                )}

                {activeTab === 'bids' && (
                    <CarrierBids
                        bids={freight.bids}
                        freightId={freight.id}
                        totalBids={freight.verificationOverview.total}
                    />
                )}

                {(activeTab === 'documents' || activeTab === 'activity') && (
                    <Card>
                        <CardBody>
                            <div className="alert m-0" role="alert">
                                <p className="text-center mb-0">
                                    {t('This section is empty')}
                                </p>
                            </div>
                        </CardBody>
                    </Card>
                )}
            </Container>
        </div>
    );
};

export default withNamespaces()(
    GuardFreightDetails
);
